import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import RebatesRCTIInvoiceList from './RebatesRCTIInvoiceList';
import RebatesRCTIBasicDetail from './RebatesRCTIBasicDetail';
import RCTIInvoicesTotal from './RCTIInvoicesTotal';
import { push } from '../../utils/navigation';
import { BASE_URL } from '../../constants';
import {cancelRebatesRCTI, downloadRebatesRCTI, getRebatesRCTIDetail} from '../../actions/rebatesRCTIActions';
import { mustBeArray, requestHasError } from '../../utils/lib';
import { toastr } from 'react-redux-toastr';
import { isAxiosError } from 'axios';
import { withRouter } from '../../utils/withRouter';

const RebatesRCTIDetailView = props => {
    const {dispatch, downloadRebatesRCTI, getRebatesRCTIDetail, id  } = props;
    const [currentRebateRCTI, setCurrentRebateRCTI] = useState([]);
    const [downloading, setDownloading] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);


    useEffect(() => {
        getRebateDetail();
    }, []);

    const handleDownload = () => {
        setDownloading(true);
        dispatch(downloadRebatesRCTI({id: id})).then(x => {
            setDownloading(false);
        });
    };

    const getRebateDetail = () => {
        dispatch(getRebatesRCTIDetail({id: id})).then(resp => {
            if (!requestHasError({x: resp})) {
                setCurrentRebateRCTI(resp.data);
              } 
        });
    };

    const onCancel = async () => {
        try {
            setIsCancelling(true);
            await cancelRebatesRCTI(id);
            toastr.success("Cancelled RCTI");
            goBack();
        } catch (error) {
            toastr.error("Failed to cancel RCTI. Please try again");
            if(isAxiosError(error)){
                if(error.response.data.Errors){
                    mustBeArray(error.response.data.Errors).forEach(e => {
                    toastr.error(e.Message || "");
                    });
                }
            }
        } finally {
            setIsCancelling(false);
        }
    };

    const goBack = () => {
        dispatch(push(`${BASE_URL}/rebatesRCTI`));
    };
    return(
        <React.Fragment>
            <div className={"row"}>
                <div className={"col-12"} style={{marginBottom: "24px"}}>
                    <h4>View Rebates RCTI</h4>
                </div>
            </div>
            <RebatesRCTIBasicDetail 
                rctiDetails = {currentRebateRCTI}
                editMode={false}
            />
            <RebatesRCTIInvoiceList 
                detailView={true}
                data={mustBeArray(currentRebateRCTI.rebateRctiLines)}
            />
            <div className="mt-2 full-width">
                <RCTIInvoicesTotal
                    totalRebateAmount={currentRebateRCTI.totalRebateAmount}
                    totalRebateAmountExcGst={currentRebateRCTI.totalRebateAmountExcGst}
                    gstAmount={currentRebateRCTI.gstAmount}
                />
            </div>
            <div className="mt-2">
                <button className={`btn btn-primary ${downloading?"no-pointer-events":""}`} onClick={handleDownload}>
                    <i className="fa fa-arrow-down" aria-hidden="true"></i> &nbsp;{downloading ? "Downloading": "Download RCTI"}</button>
                <button className="btn btn-default ml-1" onClick={goBack}>
                    <i className="fa fa-arrow-left" aria-hidden="true"></i> &nbsp;Back
                </button>
                <button className="btn btn-default ml-1 float-right" onClick={onCancel} disabled={isCancelling}>
                    <i className="fa fa-times" aria-hidden="true"></i> &nbsp;{isCancelling ? "Cancelling" : "Cancel RCTI"}
                </button>
            </div>
        </React.Fragment>
    );
};

function mapStateToProps(state, ownProps){
    
    const id = parseInt(ownProps.routeParams.id);
    return {
        invoiceList: state.rebatesRCTI && state.rebatesRCTI.invoices && state.rebatesRCTI.invoices.items,
        gst: Number(state.apiConfig && state.apiConfig.gst),
        id,
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      dispatch,
      downloadRebatesRCTI,
      getRebatesRCTIDetail
    };
  }

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RebatesRCTIDetailView));